import { useQuery } from "@tanstack/react-query";
import { ApiGetFortAgentSkuConfig, ApiGetUserInfo } from "@/api";
import { GetFortAgentSkuConfigResponse } from "@/api/types";
import { getToken } from "@/lib/auth";

export function useFortAgentSkuConfig() {
  return useQuery({
    queryKey: ["fortAgentSkuConfig"],
    queryFn: async () => {
      const token = getToken();
      const res = token ? await ApiGetFortAgentSkuConfig() : null;
      const userInfo = token ? await ApiGetUserInfo() : null;
      console.log("useFortAgentSkuConfig", userInfo);
      if (!token || userInfo?.data?.team === "A") {
        return {
          skus: [
            {
              skuId: "100",
              tier: 100,
              name: "PRO 1",
              basePriceUsdt: "1000000000000000000000",
              aiManageAddSpeed: 500,
              exitMultiple: 200,
              staticDailyRateBpms: 10000,
              staticPayoutRequireTeamLevel: 1,
              aifValueUsdt: "1000000000000000000000",
              aifDistributeDays: 100,
              giveLevel: 1,
              giveLevelStartAt: 1779285600000,
              giveLevelExpireAt: 1781964000000,
              supplyCap: 500,
              effectiveFrom: 1777248000000,
              effectiveTo: 2091369600000,
              mixedFusdShareBp: 3000,
              supportsMixed: true,
              leftSupplyCount: 0,
              sellCount: 157,
              sellPriceUsdt: "1180000000000000000000",
            },
            {
              skuId: "200",
              tier: 200,
              name: "PRO 2",
              basePriceUsdt: "3000000000000000000000",
              aiManageAddSpeed: 1000,
              exitMultiple: 300,
              staticDailyRateBpms: 11000,
              staticPayoutRequireTeamLevel: 2,
              aifValueUsdt: "3000000000000000000000",
              aifDistributeDays: 100,
              giveLevel: 2,
              giveLevelStartAt: 1779285600000,
              giveLevelExpireAt: 1781964000000,
              supplyCap: 300,
              effectiveFrom: 1777248000000,
              effectiveTo: 2091369600000,
              mixedFusdShareBp: 3000,
              supportsMixed: true,
              leftSupplyCount: 0,
              sellCount: 26,
              sellPriceUsdt: "3540000000000000000000",
            },
            {
              skuId: "300",
              tier: 300,
              name: "PRO 3",
              basePriceUsdt: "5000000000000000000000",
              aiManageAddSpeed: 1500,
              exitMultiple: 400,
              staticDailyRateBpms: 12000,
              staticPayoutRequireTeamLevel: 3,
              aifValueUsdt: "5000000000000000000000",
              aifDistributeDays: 100,
              giveLevel: 3,
              giveLevelStartAt: 1779285600000,
              giveLevelExpireAt: 1781964000000,
              supplyCap: 100,
              effectiveFrom: 1777248000000,
              effectiveTo: 2091369600000,
              mixedFusdShareBp: 3000,
              supportsMixed: true,
              leftSupplyCount: 0,
              sellCount: 58,
              sellPriceUsdt: "5900000000000000000000",
            },
            {
              skuId: "400",
              tier: 400,
              name: "PRO 4",
              basePriceUsdt: "10000000000000000000000",
              aiManageAddSpeed: 2000,
              exitMultiple: 500,
              staticDailyRateBpms: 13000,
              staticPayoutRequireTeamLevel: 4,
              aifValueUsdt: "10000000000000000000000",
              aifDistributeDays: 100,
              giveLevel: 4,
              giveLevelStartAt: 1779285600000,
              giveLevelExpireAt: 1781964000000,
              supplyCap: 50,
              effectiveFrom: 1777248000000,
              effectiveTo: 2091369600000,
              mixedFusdShareBp: 3000,
              supportsMixed: true,
              leftSupplyCount: 0,
              sellCount: 26,
              sellPriceUsdt: "11800000000000000000000",
            },
            {
              skuId: "500",
              tier: 500,
              name: "PRO 5",
              basePriceUsdt: "20000000000000000000000",
              aiManageAddSpeed: 3000,
              exitMultiple: 600,
              staticDailyRateBpms: 15000,
              staticPayoutRequireTeamLevel: 5,
              aifValueUsdt: "20000000000000000000000",
              aifDistributeDays: 100,
              giveLevel: 5,
              giveLevelStartAt: 1779285600000,
              giveLevelExpireAt: 1781964000000,
              supplyCap: 50,
              effectiveFrom: 1777248000000,
              effectiveTo: 2091369600000,
              mixedFusdShareBp: 3000,
              supportsMixed: true,
              leftSupplyCount: 0,
              sellCount: 77,
              sellPriceUsdt: "23600000000000000000000",
            },
          ],
        } as GetFortAgentSkuConfigResponse;
      }
      return res!.data;
    },
    refetchInterval: 3000,
    retry: 3,
  });
}
